<!--
 * @Description: ================== 游戏介绍 =================
 * @Date: 2022-05-13 18:08:07
 * @Author: Zero
 * @FilePath: \guobao-web\src\components\Game.vue
 * @LastEditors: Zero
 * @LastEditTime: 2022-06-14 14:51:49
-->
<template>
  <div class="page page-game">
    <div style="margin-top:20px">
      <img src="/banner.jpg" alt="" style="width: 100%" />
    </div>
    <h2 class="title">游戏介绍</h2>
    <p>欢迎来到龙珠宇宙，缔结战士羁绊，与赛亚人奔赴星际激战！这片浩瀚宇宙，等待你的征服。</p>
    <!-- <pre> -->
    <div class="content">
      <div class="content-item">
        <h4>【离线挂机，速养赛亚战士】</h4>
          修行不受时限束缚！离线自动积攒修炼资源，每位战士全天候稳步变强，上线一键收取海量养成材料，等级战力飞速飙升，宇宙强者轻松养成！
        <img src="/1.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【无限连抽，集结全系列战士】</h4>
          强力战士无需苦等！完成新手试炼，海量抽取机会即刻领取。悟空全形态、贝吉塔、弗利萨悉数登场，组建专属赛亚战队，续写龙珠全新冒险！
        <img src="/2.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【阵营羁绊，复刻原作必杀技】</h4>
          迎战宇宙各路强敌，在星际关卡深处对决反派 BOSS！激活角色阵营羁绊，自由搭配阵容，释放龟派气功、合体变身等经典原作必杀，打出高额合击伤害，称霸星际战场！
        <img src="/3.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【集齐龙珠，登顶宇宙巅峰】</h4>
          从新手战士到宇宙最强，你的每一场战斗、每一次角色突破，都会记录在宇宙榜单。集结全部经典战士，解锁终极合体战术，成为纵横全宇宙的最强勇者！
        <img src="/4.jpg" alt="" />
      </div>
    </div>
    <!-- </pre> -->
  </div>
</template>

<style scss>
.content-item {
  display: inline-block;
  width: 50%;
  padding: 12px;
  box-sizing: border-box;
  vertical-align: top;
}
.content-item img {
  display: block;
  margin-top: 12px;
  width: 400px;
}
@media screen and (max-width: 768px) {
  .content-item {
    width: 100%;
  }
  .content-item img {
    width: 100%;
  }
}
</style>
